import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

const TITLES = {
  "/": "Yadid Advisory | Trusted Strategic Advisory",
  "/about": "About Yadid Advisory | The Trusted Advisor",
  "/how-we-advise": "How We Advise | Yadid Advisory",
  "/capabilities": "Strategic Advisory Capabilities | Yadid Advisory",
  "/journeys": "Yadid Journeys | Immersive Leadership Journeys",
  "/insights": "Insights | Yadid Advisory",
  "/contact": "Start a Conversation | Yadid Advisory",
};

export const Layout = () => {
  const { pathname } = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  useEffect(() => {
    document.title = TITLES[pathname] || "Yadid Advisory";
    if (lenisRef.current) {
      lenisRef.current.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return (
    <div className="min-h-screen bg-ivory">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
